/*
 * Copyright (c) Dito Technologies LLC
 */

import React  from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    SheetRenderer_piece$data
} from "ui/feature/piece-play/common/sheet-renderer/__generated__/SheetRenderer_piece.graphql";
import styles from "./SheetRenderer.module.scss"
import SheetRendererNote from "ui/feature/piece-play/common/sheet-renderer/SheetRendererNote";
import {BulbIdToStateLookup} from "ui/feature/piece-play/common/PlayTypes";

interface Props {
    piece: SheetRenderer_piece$data;
    playPosition: number;
    bulbIdToStateLookup: BulbIdToStateLookup;
}

const SheetRenderer: React.FC<Props> = ({piece, bulbIdToStateLookup}) => {

    const currentSheet = React.useMemo(() => {
        return piece.sheets[0]; // TODO (dito) need to do this,  but not for the demo
    }, [piece.sheets])

    return (
        <div className={styles.container}>
            {piece.file?.notes.map((note) => (
                <SheetRendererNote
                    state={bulbIdToStateLookup[note.bulb_id] || "none"}
                    currentSheetId={currentSheet.id}
                    key={note.bulb_id}
                    pageWidth={currentSheet.width}
                    pageHeight={currentSheet.height}
                    note={note} />))}
            <img className={styles.image} src={currentSheet.thumbnail_download_url}  alt={"Sheet Music Page"}/>
        </div>
    );
}

export default createFragmentContainer(SheetRenderer, {
    piece: graphql`
    fragment SheetRenderer_piece on MusicPiece {
        id
        file {
            notes {
                bulb_id
                ...SheetRendererNote_note
            }
        }
        sheets {
            id
            width
            height
            thumbnail_download_url
        }
    }
    `
});
